<template>
  <div class="index_main">
    <div class="index_main2">
      <div class="index_top">

      </div>
      <div class="index_logo">
        <img :src="'/static/images/'+navtable+'/indexlogo.png'" style="width:59%;height:0.72rem;"/>
      </div>
      <div class="index_table">
        <div style="width:100;height:.2rem;"></div>
        <div style="font-size:1rem;color:red;width:100%;text-align:center;">
          <template>{{datalist.Type}}{{datalist.OrderID}}</template>
        </div>
        <div style="font-size:.32rem;width:100%;text-align:center;">
          <template v-if="datalist.Type=='A'">小桌</template>
          <template v-if="datalist.Type=='B'">中桌</template>
          <template v-if="datalist.Type=='C'">大桌</template>
        </div>
        <div
          style="width:90%;margin:0 auto;display:flex;justify-content:space-between;font-size:.36rem;font-weight:bold;margin-top:.5rem;">
          <div>取号时间</div>
          <div>{{datalist.OpTime}}</div>
        </div>
        <div
          style="width:90%;margin:0 auto;display:flex;justify-content:space-between;font-size:.36rem;font-weight:bold;margin-top:.5rem;">
          <div>还需等待</div>
          <div>{{datalist.DeskNumber}}桌</div>
        </div>
        <div
          style="width:90%;margin:0 auto;display:flex;justify-content:space-between;font-size:.36rem;font-weight:bold;margin-top:.5rem;">
          <div>已等待</div>
          <div>{{datalist.WaitTime}}分钟</div>
        </div>
        <div style="width:92%;margin:.5rem auto;font-size:.35rem;font-weight:bold;color: chocolate;">
          <template v-if="navtable=='sh'">听到叫号请及时到前台；过号作废,需重新取号【实际规则以门店线下说明为准】</template>
          <template v-if="navtable=='lll'">听到叫号请及时到前台；【实际规则以门店线下说明为准】</template>
        </div>
        <div style="width:92%;margin:.5rem auto;font-size:.35rem;font-weight:bold;text-align: left;">【排队规则】</div>
        <div style="width:88%;margin:.5rem auto 0 auto;font-size:.35rem;font-weight:bold;text-align: left;">
          <template v-if="navtable=='sh'">本店过号自动作废！不顺延！！！</template>
          <template v-if="navtable=='lll'">本店过号顺延3桌！！！感谢您的配合！</template>
        </div>
        <div style="width:88%;margin:0 auto;font-size:.35rem;font-weight:bold;text-align: left;">
          为避免您过号建议您提前5-10桌到现场等位！
        </div>
      </div>
      <div style="width:100%;height:1.6rem;"></div>
    </div>

  </div>
</template>

<script>
  import {
    Dialog
  } from 'vant-green';
  import 'swiper/swiper-bundle.css'
  import throttle from '../../static/js/throttle.js'
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper"
  export default {
    name: 'App',
    data() {
      return {
        datalist:{},
        navtable:"sh"
      }
    },
    computed: {

    },
    components: {},
    methods: {
      geidata(){
        console.log(1131)
        var that=this
        var ID=this.$route.query.ID
        var ShopID=this.$route.query.Shopid
        this.axios.get(this.$lujin + "/api/Default/PushWaitInfo?ID=" + ID + "&ShopID=" + ShopID)
          .then((res) => {
            console.log(res.data)
            if(res.data.State){
              var OrderNumber=res.data.OrderNumber
              var timexb=0
              var ordertime=setInterval(()=>{
                timexb++;
                if(timexb>=10){
                  clearInterval(ordertime)
                }
                that.axios.get(that.$lujin + "/api/Default/GetWaitInfo?ID=" + ID + "&ShopID=" + ShopID+"&OrderNumber="+OrderNumber)
                .then((bpq) => {
                  console.log(bpq.data)
                  if(bpq.data.State){
                    console.log(bpq.data.Data[0])
                    that.datalist=bpq.data.Data[0]
                    clearInterval(ordertime)
                  }
                })
              },1000)
            }
        })
      }
    },
    mounted() {
      if (this.$route.query.Shopid =="2505136688") {
        this.navtable="lll"
      }else if (this.$route.query.Shopid =="10088") {
        this.navtable="pyd"
      }
      this.geidata()
    }
  }
</script>

<style scoped>
  @keyframes blink {
    0%{color:red;}
    14.28%{color:orange;}
    28.57%{color:yellow;}
    42.85%{color:green;}
    57.14%{color:blue;}
    71.42%{color:indigo;}
    85.71%{color:violet;}
    100% {color:red;}
  }
  .textxg {
    animation: blink 3.5s infinite;
  }
  .index_xd2 {
    margin: .5rem auto 0 auto;
    width: 40%;
    height: .8rem;
    background: url(/static/images/sh/bababababab.png);
    background-size: 100% 100%;
    font-size: .36rem;
    font-weight: bold;
    text-align: center;
    line-height: .8rem;
    color: #fff;
  }

  .index_tips {
    width: 90%;
    margin: .2rem auto;
    font-size: .3rem;
    font-weight: bold;
    line-height: .36rem;
    text-align: left;
  }

  .index_biaoge_right {
    width: 20%;
    text-align: center;
    border-bottom: 0.5px solid #999;
  }

  .index_biaoge_left2 {
    width: 80%;
    border-right: 0.5px solid #999;
    border-bottom: 0.5px solid #999;
    text-align: left;
    font-size: .3rem;
    text-indent: .2rem;
  }

  .index_biaoge_left {
    width: 80%;
    border-right: 0.5px solid #999;
    border-bottom: 0.5px solid #999;
  }

  .index_biaoge_main_li {
    display: flex;
    height: .8rem;
    line-height: .8rem;
  }

  .index_biaoge_main {
    width: 100%;
    height: 9rem;
    overflow-y: scroll;
  }

  .index_biaoge_top {
    font-weight: bold;
    width: 100%;
    display: flex;
    height: .8rem;
    line-height: .8rem;
  }

  .index_biaoge {
    width: 90%;
    height: 10rem;
    border-radius: 0 0 .2rem .2rem;
    border: 2px solid #000;
    box-sizing: border-box;
    background: #fff;
    margin: .1rem auto;
    font-size: .36rem;
  }

  .index_cxdd {
    width: 90%;
    height: .5rem;
    line-height: .5rem;
    background: url(/static/images/sh/lists_top.png);
    background-size: 100% 100%;
    margin: 0 auto 0 auto;
    font-size: .28rem;
    font-weight: bold;
    color: #fff;
  }

  .index_sfxd_butt div {
    background: url(/static/images/sh/bababababab.png);
    background-size: 100% 100%;
    width: 2.4rem;
    height: .8rem;
    line-height: .8rem;
    color: #fff;
  }

  .index_sfxd_butt {
    margin: .2rem 0 0 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .index_sfxd_table {
    line-height: 1rem;
  }

  .index_sfxd_main div {
    font-size: .4rem;
    font-weight: bold;
  }

  .index_sfxd_main {
    width: 84%;
    left: 8%;
    position: absolute;
    height: 2.4rem;
    background: #fff;
    border: 2px solid #000;
    top: 60%;
    border-radius: .3rem;
  }

  .index_sfxd {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
  }

  .index_xhc_img img {
    width: 100%;
    height: 100%;
    float: left;
  }

  .index_xhc_img {
    width: 23%;
    margin: 0 1%;
    height: .65rem;
  }

  .index_xhc_main {
    width: 57%;
    display: flex;
    margin: 0 auto;
  }

  .index_xd {
    margin: .2rem auto 0 auto;
    width: 33%;
    height: .72rem;
    background: url(/static/images/sh/shdcxd.png);
    background-size: 100% 100%;
  }

  @keyframes moveLeft {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(0%);
    }
  }

  @keyframes moveRight {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(-100%);
    }
  }

  .index_xhc4 {
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: rgba(0, 0, 0, 0);
    background-size: 100% 100%;
  }

  .index_xhc4 .index_xhc_main {
    display: none;
  }

  .index_xhc3 {
    animation: moveLeft 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/sh/shdcxhc.png);
    background-size: 100% 100%;
  }

  .index_xhc2 {
    animation: moveRight 1s linear infinite;
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/sh/shdcxhc.png);
    background-size: 100% 100%;
  }

  .index_xhc {
    width: 95%;
    margin: .2rem auto;
    height: 1.45rem;
    background: url(/static/images/sh/shdcxhc.png);
    background-size: 100% 100%;
  }

  .index_Goods_Goods .index_Goods_Goods2 {
    width: 100%;
    height: .4rem;
    line-height: .4rem;
    font-size: .2rem;
    background: #315858;
    color: yellow;
    border-radius: 0 0 .12rem .12rem;
    position: relative;
  }

  .index_Goods_Goods img {
    width: 100%;
    height: 100%;
    border-radius: .12rem .12rem 0 0;
  }

  .index_Goods_Goods .index_Goods_Goods1 {
    width: 100%;
    height: 1.3rem;
  }

  .index_Goods_Goods {
    width: 31.9%;
    margin: 0 0.7%;
    height: 1.8rem;
    position: relative;
  }

  .index_Goods_swiper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .index_Goods swiper {
    width: 100%;
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }

  .index_table_navbj {
    width: 100%;
    height: 100%;
    background: url(/static/images/sh/Menubj.png);
    background-size: 100% 100%;
    position: absolute;
    top: 0;
  }

  .index_table_navtext {
    font-size: .2rem;
    color: #fff;
    font-weight: bold;
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
  }

  .index_table_navimg {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .index_table_nav2 {
    width: 40%;
    height: 1.32rem;
    margin-top: .1rem;
    background: url(/static/images/sh/djxd.png);
    background-size: 100% 100%;
  }

  .index_table_navs {
    margin: 0 -2%;
    width: 24%;
    height: 1.3rem;
    position: relative;
  }

  .index_Goods {
    width: 98%;
    margin: 0 auto;
  }

  .index_table_nav {
    width: 96%;
    margin: 0 auto;
    display: flex;
  }

  .index_table {
    width: 95%;
    height: 10.2rem;
    margin: .5rem auto;
    background: url(/static/images/sh/smdcbjbj.png);
    background-size: 100% 100%;
    position: relative;
  }

  .index_logo2 {
    width: 34.7%;
    height: .72rem;
    background: url(/static/images/sh/indexddxq.png);
    background-size: 100% 100%;
  }


  .index_logo {
    width: 95%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }

  .index_top {
    width: 100%;
    height: .8rem;
    line-height: .8rem;
    font-size: .4rem;
    text-align: center;
    font-weight: bold;
  }

  .index_main2 {
    width: 100%;
    height: 100%;
  }

  .index_main {
    width: 100%;
    height: 100%;
    background: url(/static/images/sh/smdcbj.jpg);
    background-size: 100% 100%;
  }

  #loader-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
  }

  #loader {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border-radius: 50%;
    border: 3px solid transparent;
    /* COLOR 1 */
    border-top-color: orange;
    -webkit-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -ms-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -moz-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -o-animation: spin 2s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 2s linear infinite;
    /* Chrome, Firefox 16+, IE 10+, Opera */
    z-index: 1001;
  }

  #loader:before {
    content: "";
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    border-radius: 50%;
    border: 3px solid transparent;
    /* COLOR 2 */
    border-top-color: orange;
    -webkit-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -moz-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -o-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -ms-animation: spin 3s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 3s linear infinite;
    /* Chrome, Firefox 16+, IE 10+, Opera */
  }

  #loader:after {
    content: "";
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: orange;
    /* COLOR 3 */
    -moz-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -o-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -ms-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    -webkit-animation: spin 1.5s linear infinite;
    /* Chrome, Opera 15+, Safari 5+ */
    animation: spin 1.5s linear infinite;
    /* Chrome, Firefox 16+, IE 10+, Opera */
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(0deg);
      /* IE 9 */
      transform: rotate(0deg);
      /* Firefox 16+, IE 10+, Opera */
    }

    100% {
      -webkit-transform: rotate(360deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(360deg);
      /* IE 9 */
      transform: rotate(360deg);
      /* Firefox 16+, IE 10+, Opera */
    }
  }

  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(0deg);
      /* IE 9 */
      transform: rotate(0deg);
      /* Firefox 16+, IE 10+, Opera */
    }

    100% {
      -webkit-transform: rotate(360deg);
      /* Chrome, Opera 15+, Safari 3.1+ */
      -ms-transform: rotate(360deg);
      /* IE 9 */
      transform: rotate(360deg);
      /* Firefox 16+, IE 10+, Opera */
    }
  }

  #loader-wrapper .loader-section {
    position: fixed;
    top: 0;
    width: 51%;
    height: 100%;
    background: #FFF;
    /* Old browsers */
    z-index: 1000;
    -webkit-transform: translateX(0);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateX(0);
    /* IE 9 */
    transform: translateX(0);
    /* Firefox 16+, IE 10+, Opera */
  }

  #loader-wrapper .loader-section.section-left {
    left: 0;
  }

  #loader-wrapper .loader-section.section-right {
    right: 0;
  }

  /* Loaded */
  .loaded #loader-wrapper .loader-section.section-left {
    -webkit-transform: translateX(-100%);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateX(-100%);
    /* IE 9 */
    transform: translateX(-100%);
    /* Firefox 16+, IE 10+, Opera */
    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
  }

  .loaded #loader-wrapper .loader-section.section-right {
    -webkit-transform: translateX(100%);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateX(100%);
    /* IE 9 */
    transform: translateX(100%);
    /* Firefox 16+, IE 10+, Opera */
    -webkit-transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
    transition: all 0.7s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1.000);
  }

  .loaded #loader {
    opacity: 0;
    -webkit-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
  }

  .loaded #loader-wrapper {
    visibility: hidden;
    -webkit-transform: translateY(-100%);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: translateY(-100%);
    /* IE 9 */
    transform: translateY(-100%);
    /* Firefox 16+, IE 10+, Opera */
    -webkit-transition: all 0.3s 1s ease-out;
    transition: all 0.3s 1s ease-out;
  }

  /* JavaScript Turned Off */
  .no-js #loader-wrapper {
    display: none;
  }

  .no-js h1 {
    color: #222222;
  }

  #loader-wrapper .load_title {
    font-family: 'Open Sans';
    color: orange;
    font-size: 19px;
    width: 100%;
    text-align: center;
    z-index: 9999999999999;
    position: absolute;
    top: 70%;
    opacity: 1;
    line-height: 30px;
  }

  #loader-wrapper .load_title span {
    font-weight: normal;
    font-style: italic;
    font-size: 13px;
    color: #FFF;
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/shjh.vue